// eslint-disable-next-line no-undef
export const DEV_MODE = process.env.NODE_ENV !== "production";

export const REDUX_PROMISE_MIDDLEWARE_SUFFIXES = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
